"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Dieser ID-Generator generiert alphanumerische IDs in einer Länge von 7
 * Zeichen. Die Länge garantiert eine sehr hohe Anzahl von IDs, bevor es zu
 * Kollisionen kommen kann (36^7 IDs, ungefähr 78 Milliarden).
 * Weiterhin wird ein alphanumerischer Prefix der Länge 5 generiert, falls
 * kein Prefix gesetzt wird. Somit wird eine Kollision verhindert bei
 * Verwendung mehrere Provider auf einer Seite, z.B. dem Styleguide
 */
var IdGenerator = /** @class */ (function () {
    function IdGenerator(context) {
        this.index = 0;
        this.prefix = context || this.generateRandomPrefix();
    }
    IdGenerator.prototype.next = function () {
        var id = this.index.toString(36);
        this.index += 1;
        // fixed padding to 7 chars
        var s = "000000" + id;
        return "" + this.prefix + s.slice(-7);
    };
    IdGenerator.prototype.generateRandomPrefix = function () {
        return Math.random()
            .toString(36)
            .substring(2, 7);
    };
    return IdGenerator;
}());
exports.IdGenerator = IdGenerator;
exports.default = IdGenerator;
//# sourceMappingURL=IdGenerator.js.map
